import { useState } from "react"
import "./ContestTabs.scss"
import { gettext } from "@multimediallc/web-utils"
import { useAppContext } from "../../../hooks/appContext"
import { Tabs } from "../../common/organisms/Tabs"
import { ContestClaimWinnings } from "../ContestClaimWinnings"
import { ContestPreviousWinners } from "../ContestPreviousWinners"
import { ContestRules } from "../ContestRules"
import { ContestStats } from "../ContestStats"
import type { ITabItem } from "../../common/organisms/Tabs"

const i18n = {
    contestRulesAndFAQText: gettext("Contest Rules & FAQ"),
    previousWinnersText: gettext("Previous Winners"),
    claimYourWinningsText: gettext("Claim Your Winnings"),
    topCamsText: gettext("Top Cams"),
}

const CONTEST_TABS: ITabItem[] = [
    {
        tabId: "contest-rules-and-faq",
        text: i18n.contestRulesAndFAQText,
        TabComponent: <ContestRules />,
    },
    {
        tabId: "previous-winners",
        text: i18n.previousWinnersText,
        TabComponent: <ContestPreviousWinners />,
    },
    {
        tabId: "claim-your-winnings",
        text: i18n.claimYourWinningsText,
        TabComponent: <ContestClaimWinnings />,
    },
    {
        tabId: "top-cams",
        text: i18n.topCamsText,
        TabComponent: (
            <ContestStats show={true} withAdditionalDetails={false} />
        ),
    },
]

export function ContestTabs() {
    const isAnon = useAppContext().context.logged_in_user === null
    const [contestTabs] = useState<ITabItem[]>(() => {
        // Do not render claim winnings tab for anons
        return isAnon
            ? CONTEST_TABS.filter((tab) => tab.tabId !== "claim-your-winnings")
            : CONTEST_TABS
    })

    return (
        <div className="ContestTabs">
            <Tabs tabs={contestTabs} />
        </div>
    )
}
